(function () {
  'use strict';

  /* ── Reading progress bar ──────────────────────────── */
  var bar = document.getElementById('reading-progress');
  if (bar) {
    function tick() {
      var s = document.documentElement.scrollTop || document.body.scrollTop;
      var h = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      bar.style.width = (h > 0 ? (s / h) * 100 : 0) + '%';
    }
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  /* ── Read time ─────────────────────────────────────── */
  var contentEl  = document.querySelector('.article__content');
  var readTimeEl = document.getElementById('article-read-time');
  if (contentEl && readTimeEl) {
    var words = ((contentEl.innerText || contentEl.textContent || '').match(/\S+/g) || []).length;
    readTimeEl.textContent = Math.max(1, Math.ceil(words / 200)) + ' min read';
  }

  /* ── Table of Contents ─────────────────────────────── */
  var tocNav = document.getElementById('toc-nav');
  if (!contentEl || !tocNav) return;

  // skip empty headings (pasted bodies sometimes carry <h2><span></span></h2>; it showed as a blank TOC entry)
  var headings = Array.from(contentEl.querySelectorAll('h2, h3')).filter(function (h) { return (h.textContent || '').trim(); });

  if (headings.length < 2) {
    var sidebar = document.querySelector('.article-enhanced__sidebar');
    if (sidebar) sidebar.style.display = 'none';
    var layout = document.querySelector('.article-enhanced');
    if (layout) layout.style.gridTemplateColumns = '1fr';
    return;
  }

  /* 2026-10-13 (Guido: "update the TOCs, could be cooler"): numbered sections in the mono font, a reading-progress
     line for this article, and the same list as a collapsible box above the text on phones and tablets, where the
     sidebar is hidden. Both lists share one active-section highlight. */
  var n = 0;
  function buildList() {
    var ol = document.createElement('ol');
    ol.className = 'toc-list';
    headings.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      if (h.tagName === 'H3') {
        li.className = 'toc-h3';
      } else {
        var num = document.createElement('span');
        num.className = 'toc-n';
        num.setAttribute('aria-hidden', 'true');
        num.textContent = String(h.dataset.tocN).padStart(2, '0');
        a.appendChild(num);
      }
      var t = document.createElement('span');
      t.textContent = h.dataset.tocLabel || h.textContent;
      a.appendChild(t);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: 'smooth' });
        history.replaceState(null, '', '#' + h.id);
        var d = a.closest('details');
        if (d) d.open = false;
      });
      li.appendChild(a);
      ol.appendChild(li);
    });
    return ol;
  }
  headings.forEach(function (h, i) {
    if (!h.id) {
      h.id = 'h' + i + '-' + (h.textContent || '')
        .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    if (h.tagName === 'H2') { n += 1; h.dataset.tocN = n; }
  });

  var progress = document.createElement('div');
  progress.className = 'toc-progress';
  progress.setAttribute('aria-hidden', 'true');
  progress.appendChild(document.createElement('span'));
  tocNav.appendChild(progress);
  tocNav.appendChild(buildList());

  var mobile = document.createElement('details');
  mobile.className = 'toc-mobile';
  var sum = document.createElement('summary');
  sum.innerHTML = '<span>In this article</span><span class="toc-mobile__count">' + headings.length + ' sections</span>';
  var mnav = document.createElement('nav');
  mnav.setAttribute('aria-label', 'In this article');
  mnav.appendChild(buildList());
  mobile.appendChild(sum);
  mobile.appendChild(mnav);
  contentEl.parentNode.insertBefore(mobile, contentEl);

  /* Reading progress through the article body */
  var fill = progress.firstChild;
  function prog() {
    var r = contentEl.getBoundingClientRect();
    var p = (window.innerHeight * 0.3 - r.top) / Math.max(1, r.height);
    fill.style.width = Math.max(0, Math.min(1, p)) * 100 + '%';
  }
  window.addEventListener('scroll', prog, { passive: true });
  prog();

  /* Active section highlight via IntersectionObserver */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      document.querySelectorAll('.toc-list a.toc-active').forEach(function (l) { l.classList.remove('toc-active'); });
      document.querySelectorAll('.toc-list a[href="#' + entry.target.id + '"]').forEach(function (l) { l.classList.add('toc-active'); });
    });
  }, { rootMargin: '-4% 0px -92% 0px', threshold: 0 });

  headings.forEach(function (h) { io.observe(h); });
}());
